<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="block">
          <el-date-picker
            type="months"
            v-model="filters.months"
            size="mini"
            @change="getList"
            placeholder="选择一个或多个月">
          </el-date-picker>
        </div>
      </div>
      <div class="filter__item">
        <adSelect v-model="filters.adid" :lists.sync="adLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">负责人：</div>
        <operSelect v-model="filters.opid" :lists.sync="operLists" :filterLists.sync="operFilterLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">广告名：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">上家：</div>
        <aderSelect v-model="filters.arid" :lists.sync="aderLists"/>
      </div>
      <button class="blue-small-btn mr-10" @click="getList">搜索</button>
    </div>
    <div class="filter mt-10 mb-20">
      <div class="filter__item">
        <div class="filter__name">回款进度：</div>
        <el-select class="filter__input" size="mini" v-model="filters.proccess">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in proccessLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <button class="blue-small-btn mr-20"  @click="dialogVisible = true">一键汇总</button>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
          center>
          <span>是否立即汇总广告每月数据</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="summaryAdDsData">确 定</el-button>
          </span>
        </el-dialog>
        <button class="blue-small-btn" @click="download()">导出数据</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700" :summary-method="getSummaries" show-summary>
      <el-table-column prop="month" label="月份" width="" align="center">
      </el-table-column>
      <el-table-column prop="adid" label="广告" width="" align="center" sortable>
        <template slot-scope="scope">
          <router-link :to="{path: '/adOrder', query: {adid: scope.row.adid}}" target='_blank'>{{scope.row.title}}({{scope.row.adid}})</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="oper_nickname" label="负责人" width="" align="center">
      </el-table-column>
      <el-table-column prop="aver_name" label="上家" width="" align="center">
      </el-table-column>
      <!--
      <el-table-column prop="opid" label="负责人" width="100" align="center">
        <template slot-scope="scope">
          <el-select size="mini" v-model="scope.row.opid"  @change="updateDsMonthData(scope.$index)">
            <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists" :key="index"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="aver_name" label="上家" width="100px" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.revise">
            <el-input v-model="scope.row.aver_name" :disabled="!scope.row.revise" size="mini" @change="updateDsMonthData(scope.$index)" @blur="scope.row.revise = false">
            </el-input>
          </div>
          <div v-else @click="scope.row.revise = 1 ^ scope.row.revise">
            {{scope.row.aver_name}}
            <i class="el-icon-edit"></i>
          </div>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="aver_discount" label="上家/低价" width="100" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.aver_discount}}% / {{scope.row.min_discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="purchases" label="购买类型" width="" align="center">
      </el-table-column>
      <el-table-column prop="icount" label="订单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="quota" label="总额度" width="" align="center">
      </el-table-column>
      <el-table-column prop="payment" label="金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="income" label="收入" width="" align="center">
      </el-table-column>
      <el-table-column prop="commission" label="佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="profit" label="利润" width="" align="center">
       <template slot-scope="scope">
          <div v-if="scope.row.profit < 0" class="fc-red pointer">
            {{scope.row.profit}}
          </div>
          <div v-else> {{scope.row.profit}} </div>
        </template>
      </el-table-column>
      <el-table-column prop="estimate_profit" label="预估利润" width="" align="center">
       <template slot-scope="scope">
          <div v-if="scope.row.estimate_profit < 0" class="fc-red pointer">
            {{scope.row.estimate_profit}}
          </div>
          <div v-else> {{scope.row.estimate_profit}} </div>
        </template>
      </el-table-column>
      <el-table-column prop="proccess" label="回款进度" width="120" align="center">
        <template slot-scope="scope">
          <el-select size="mini" v-model="scope.row.proccess"  @change="updateDsMonthData(scope.$index)">
            <el-option :label="item.name" :value="item.value" v-for="(item, index) in monthProccessLists" :key="index"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="settle_time" label="结清时间" width="100" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.settle_time}}
            <i class="el-icon-edit" @click="editSettle(scope.$index)"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="receive_all" label="总回款" width="" align="center">
      </el-table-column>
      <el-table-column prop="receive_month" label="当月回款" width="" align="center">
      </el-table-column>
      <el-table-column prop="real_profit" label="真实利润" width="" align="center">
       <template slot-scope="scope">
          <div v-if="scope.row.real_profit < 0" class="fc-red pointer">
            {{scope.row.real_profit}}
          </div>
          <div v-else> {{scope.row.real_profit}} </div>
        </template>
      </el-table-column>
      <el-table-column prop="apply" label="请款" width="" align="center">
      </el-table-column>
      <el-table-column prop="receive" label="收款" width="" align="center">
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="" align="center">
      </el-table-column>
      <el-table-column prop="agency_fees" label="拍收费" width="" align="center">
      </el-table-column>
      <el-table-column prop="express_fees" label="快递费" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="状态" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 2" class="normal-btn">完结</div>
          <div v-if="scope.row.status == 1" class="normal-btn">运行</div>
          <div v-if="scope.row.status == 0" class="danger-btn">下架</div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="修改结算信息" :visible.sync="settleDialog" size="tiny" width="600px" center>
      <el-form ref="form" :model="settleInfo" label-width="80px">
        <el-form-item label="ID">
          <el-input v-model="settleInfo.id" disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="月份">
          <el-input v-model="settleInfo.month" disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="活动名称">
          <el-select placeholder="请选择" v-model="settleInfo.adid" disabled="true">
            <el-option v-for="item in adLists" :key="item.value" :label="item.title" :value="item.adid"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回款进度">
          <el-select size="mini" v-model="settleInfo.proccess">
            <el-option :label="item.name" :value="item.value" v-for="(item, index) in monthProccessLists" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结清时间">
          <el-select v-model="settleInfo.settle_time" size="mini" placeholder="请选择月份">
            <el-option v-for="item in monthLists" :key="item.name" :label="item.month" :value="item.name"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="2"  class="dataForm__input" v-model="settleInfo.remark" size="mini"></el-input>
        </el-form-item>
        <div class="flex jcc mt-30">
          <div class="blue-large-btn mr-20" @click="updateSettleInfo">保存</div>
          <div class="gray-large-btn" @click="settleDialog = false">取消</div>
        </div>
      </el-form>
    </el-dialog>
  </article>
</template>
<script>
import {dsMonthEdit, dsMonthData, downloadDsMonthData, downloadAdOrderLists, downloadDsAdDetail, summaryAdDsData} from '../../api/api'
import util from '../../script/util'
import adSelect from '../../components/data-select/adSelect.vue'
import aderSelect from '../../components/data-select/aderSelect.vue'
import operSelect from '../../components/data-select/operSelect.vue'
export default {
  name: 'dsMonthData',
  components: {
    adSelect,
    aderSelect,
    operSelect
  },
  data () {
    return {
      filters: {
        months: [],
        adid: '',
        opid: '',
        proccess: '',
        arid: '',
        aver_name: '',
        title: '',
        status: ''
      },
      lists: [],
      listLoading: false,
      dialogVisible: false,
      operFilterLists: [1, 4, 5, 16],
      monthLists: [],
      operLists: [],
      adLists: [],
      aderLists: [],
      settleDialog: false,
      settleInfo: {
        id: '',
        adid: '',
        month: '',
        proccess: '',
        settie_time: '',
        remark: ''
      },
      monthProccessLists: [],
      proccessLists: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '确实数据',
          value: 1
        },
        {
          name: '开票中',
          value: 2
        },
        {
          name: '打款中',
          value: 3
        },
        {
          name: '已结算',
          value: 4
        }
      ],
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '运行',
          value: 1
        },
        {
          name: '下架',
          value: 0
        },
        {
          name: '完结',
          value: 2
        }
      ],
      averLists: []
    }
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!['adid', 'title', 'opid', 'aver_name', 'aver_discount', 'min_discount', 'purchases', 'quota'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    summaryAdDsData () {
      summaryAdDsData({}).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.dialogVisible = false
        }
      })
    },
    editSettle (index) {
      this.settleDialog = true
      for (let key in this.settleInfo) {
        this.settleInfo[key] = this.lists[index][key]
      }
    },
    dsMonthEdit (params) {
      dsMonthEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.settleDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    updateSettleInfo () {
      let params = {
        id: this.settleInfo.id,
        proccess: this.settleInfo.proccess,
        settle_time: this.settleInfo.settle_time,
        remark: this.settleInfo.remark
      }

      this.dsMonthEdit(params)
    },
    updateDsMonthData (index) {
      let id = this.lists[index].id
      // let averName = this.lists[index].aver_name
      // let opid = this.lists[index].opid
      let proccess = this.lists[index].proccess

      let params = {
        id: id,
        // opid: opid,
        // aver_name: averName
        proccess: proccess
      }

      this.dsMonthEdit(params)
    },
    downloadAd (adid) {
      let link = downloadAdOrderLists + '?choose=' + 4
      link = link + '&adid=' + adid
      window.open(link, 'a')
    },
    download () {
      let filters = this.filters
      let link = downloadDsMonthData + '?download=1'

      if (filters.months === null) {
        let months = this.setMonthLists()
        link = link + '&months=' + months
      } else {
        let months = filters.months.map((item, index) => {
          return util.formatDate.format(item, 'yyyy-MM-dd')
        })
        link = link + '&months=' + months.join(',')
      }

      if (filters.opid !== '') {
        link = link + '&opid=' + filters.opid
      }

      if (filters.adid !== '') {
        link = link + '&adid=' + filters.adid
      }

      if (filters.title !== '') {
        link = link + '&title=' + filters.title
      }

      if (filters.arid !== '') {
        link = link + '&arid=' + filters.arid
      }

      if (filters.aver_name !== '') {
        link = link + '&aver_name=' + filters.aver_name
      }

      if (filters.proccess !== '') {
        link = link + '&proccess=' + filters.proccess
      }

      if (filters.status !== '') {
        link = link + '&status=' + filters.status
      }

      window.open(link, 'a')
    },
    downloadAdDetail () {
      let filters = this.filters
      let link = downloadDsAdDetail + '?month=' + filters.month

      window.open(link, 'a')
    },
    setMonthLists () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1

      let monthLists = []
      for (let i = 0; i < 6; i++) {
        let monthStr = (month > 9) ? month.toString() : ('0' + month)
        let yearMonth = year.toString() + '-' + monthStr + '-01'

        monthLists.push(yearMonth)

        if (month === 1) {
          year = year - 1
          month = 12
        } else {
          month = month - 1
        }
      }
      return monthLists.join(',')
    },
    getList () {
      let params = {}

      if (this.filters.months === null) {
        params['months'] = this.setMonthLists()
      } else {
        let months = this.filters.months.map((item, index) => {
          return util.formatDate.format(item, 'yyyy-MM-dd')
        })
        params['months'] = months.join(',')
      }

      if (this.filters.opid !== '') {
        params['opid'] = this.filters.opid
      }

      if (this.filters.adid !== '') {
        params['adid'] = this.filters.adid
      }

      if (this.filters.arid !== '') {
        params['arid'] = this.filters.arid
      }

      if (this.filters.title !== '') {
        params['title'] = this.filters.title
      }

      if (this.filters.aver_name !== '') {
        params['aver_name'] = this.filters.aver_name
      }

      if (this.filters.proccess !== '') {
        params['proccess'] = this.filters.proccess
      }

      if (this.filters.status !== '') {
        params['status'] = this.filters.status
      }

      this.listLoading = true
      dsMonthData(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item['revise'] = false
            item['disabled'] = true
          })
          this.lists = data.d.lists
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    let today = new Date()
    let firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
    this.filters.months = [firstDay]

    this.monthLists = util.getMonthList()
    this.monthProccessLists = this.proccessLists.slice(1, this.proccessLists.length)

    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    // 'filters.months': 'getList',
    'filters.opid': 'getList',
    'filters.adid': 'getList',
    'filters.proccess': 'getList',
    'filters.arid': 'getList',
    'filters.title': 'getList',
    'filters.aver_name': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/data/adDsMonthData.vue